import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import TableRow from 'components/Table/Desktop/TableRow'
import MobileTableRow from 'components/Table/Mobile/MobileTableRow'
import Loader from 'components/atoms/ListingsTable/Loader'

class TableBody extends Component {
  renderTableRows () {
    return this.props.listings.map((listing) => {
      return (
        <Fragment key={listing.id}>
          <MediaQuery minWidth={992}>
            <TableRow
              listing={listing}
              gridTemplateColumns={this.props.gridTemplateColumns}
              selectedFilter={this.props.selectedFilter}
              canBoostListings={this.props.canBoostListings}
            />
          </MediaQuery>
          <MediaQuery maxWidth={992}>
            <MobileTableRow
              listing={listing}
              selectedFilter={this.props.selectedFilter}
              canBoostListings={this.props.canBoostListings}
            />
          </MediaQuery>
        </Fragment>
      )
    })
  }

  render () {
    return (
      <tbody>
        {this.props.isLoading ? <tr><td><div className='mt-48'><Loader /></div></td></tr> : this.renderTableRows()}
      </tbody>
    )
  }
}

TableBody.propTypes = {
  listings: PropTypes.array,
  gridTemplateColumns: PropTypes.string,
  isLoading: PropTypes.bool,
  selectedFilter: PropTypes.string,
  canBoostListings: PropTypes.bool
}

export default TableBody
